export type LinkKind = 'internal' | 'site' | 'external' | 'other';

// Our own domains: a link to them behaves like a link to any other page of the site.
const SITE_HOSTS = new Set(['syn.is', 'www.syn.is']);

// Absolute and protocol-relative URLs to another domain open in a new tab. Links to our own domain and
// root-relative paths stay in the same tab (the latter with client-side navigation). Anything else
// (mailto:, tel:, #anchors) is rendered as a plain anchor.
export const getLinkKind = (url: string): LinkKind => {
  const trimmed = url.trim();
  if (/^(https?:)?\/\//i.test(trimmed)) {
    try {
      const { hostname } = new URL(trimmed, 'https://www.syn.is');
      return SITE_HOSTS.has(hostname.toLowerCase()) ? 'site' : 'external';
    } catch {
      return 'external';
    }
  }
  if (trimmed.startsWith('/')) {
    return 'internal';
  }
  return 'other';
};
